<template lang="pug">
div
  section.section
    screen-title(title="surveys.survey_responses_title")

    b-field(grouped group-multiline)
      b-field 
        PeriodSelector(v-model="period" @input="updateRouteParams" initial="last30")
      b-field
        LocationSelector(v-model="currentLocation" @input="updateRouteParams")
      b-field
        b-select(v-model="currentQuestion" @input="updateRouteParams")
          option(value="all" v-t="'survey_types.all'")
          option(v-for="srvType in Object.values(SURVEY_TYPES)" :key="srvType" :value="srvType") {{$t(`survey_types.${srvType}`)}}
      b-field.is-flex
        b-switch(v-model="withComments" @input="updateRouteParams") {{$t('surveys.with_comments')}}
    .box(v-for="survey in surveys" :key="survey._id")
      SurveyResponseItem(:value="survey")
    b-pagination(v-if="total"
        v-model="page"
        :total="total"
        :per-page="perPage"
        @change="updateRouteParams"
        rounded
            )
    em-loading(:active="loading" :is-full-page="false")
    empty-content(v-if="!loading && !total" title="surveys.no_survey_responses")
              
  </template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import LocationSelector from './../helpers/LocationSelector'
import PeriodSelector from '../helpers/PeriodSelector'

import SurveyResponseItem from './SurveyResponseItem.vue'
import SURVEY_TYPES from '../../../constants/surveyTypes'
export default {
  name: 'SurveysListView',
  components: {
    LocationSelector,
    PeriodSelector,
    SurveyResponseItem
  },
  props: {
    location: {type: String, default: undefined},
    from: {type: String, default: undefined},
    to: {type: String, default: undefined},
    question: {type: String, default: 'all'},
    page: {type: Number, default: 1},
    comments: {type: Boolean, default: undefined}
  },
  data() {
    return {
      loading: false,
      sortOrder: 'desc',
      perPage: 10,
      defaultSortOrder: 'desc',
      currentQuestion: undefined,
      currentLocation: undefined,
      currentPage: 1,
      period: undefined,
      SURVEY_TYPES
    }
  },
  computed: {
    ...mapState('surveys', ['total']),
    ...mapState('company', ['company']),
    ...mapGetters('surveys', ['surveys'])
  },
  watch: {
    from() {
      this.fetchData()
    },
    to() {
      this.fetchData()
    },
    location() {
      this.fetchData()
    },
    question() {
      this.fetchData()
    },
    page() {
      this.fetchData()
    },
    comments() {
      this.fetchData()
    }
  },
  async created() {
    this.sortField = 'created'
    this.currentQuestion = this.question
    this.currentLocation = this.location
    this.currentPage = this.page
    this.withComments = this.comments
    if (this.from && this.to) {
      this.period = {from: this.from, to: this.to}
    }
    if (this.period) {
      await this.fetchData()
    }
  },
  methods: {
    ...mapActions('surveys', ['fetchSurveys']),

    updateRouteParams() {
      let query = {
        question: this.currentQuestion,
        location: this.currentLocation,
        page: this.currentPage,
        comments: this.withComments,
        from: this.period && this.period.from.toISOString(),
        to: this.period && this.period.to.toISOString()
      }
      this.$router.push({name: 'SurveysList', query}).catch(() => {})
    },

    async fetchData() {
      this.loading = true
      try {
        await this.fetchSurveys({
          location: this.location,
          from: this.from,
          to: this.to,
          question: this.question === 'all' ? undefined : this.question,
          sortBy: this.sortField,
          sortDir: this.sortOrder,
          page: this.page,
          comments: this.comments,
          perPage: this.perPage
        })
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.loading = false
    },

    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.fetchData()
    }
    // onPageChange(page) {
    //   this.currentPage = page
    //   this.fetchData()
    // }
  }
}
</script>
